import React from 'react'
import { LoaderComponent, loadersSelectors } from 'Modules'
import { useSelector } from 'react-redux'

export const GlobalLoader = () => {
	const isVisible = useSelector(loadersSelectors.getGlobalLoader)

	return <LoaderComponent isVisible={isVisible} />
}
